#import "./AddressFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./TimestampsFull.graphql"

fragment CustomerFull on Customer {
  id
  allowPaymentOnInvoice
  billingAddress {
    ...AddressFull
  }
  blockedAt
  blockedBy
  cognitoId
  cognitoProvider
  company {
    cin
    name
    vat
  }
  deliveryAddresses {
    ...AddressFull
  }
  email
  fakturoidOssSubjectId
  fakturoidSubjectId
  fullName
  gdprApprovedAt
  invoiceEmail
  maximumOverdueInvoiceAmount
  locale
  phoneNumber
  pricingLevel
  subscribeToNewsletter
  ...TimestampsFull
  ...SearchIndexFull
}
